import * as React from "react"

const withEmptyHoc = WrappedComponent => {
    class WithEmptyHoc extends React.Component {
        static displayName = "withEmptyHoc(App)"
        static getInitialProps

        render() {
            return <WrappedComponent {...this.props} />
        }
    }

    if (WrappedComponent.getInitialProps) {
        WithEmptyHoc.getInitialProps = WrappedComponent.getInitialProps
    }

    return WithEmptyHoc
}

export default withEmptyHoc
